import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '../theme';

const ProfilePicture = styled.i`
  background: ${theme.colors.action};
  border-radius: 50%;
  border: solid 1px ${theme.colors.action};
  bottom: 0;
  box-shadow: 0 0 0 2px white;
  box-sizing: border-box;
  height: ${theme.unit * 1.5}px;
  overflow: hidden;
  position: absolute;
  right: 0;
  width: ${theme.unit * 1.5}px;

  &::after {
    background: ${theme.colors.white};
    border-radius: 50%;
    content: '';
    display: block;
    height: 40%;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -75%);
    width: 40%;
  }

  &::before {
    background: ${theme.colors.white};
    border-radius: 50%;
    content: '';
    display: block;
    height: 75%;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, 33.33333%);
    width: 75%;
  }
`.withComponent(({
  user, // strip
  ...props
}) => <i {...props} />);

const TeamIcon = styled(({ name, user, small, ...props }) => (
  <i {...props}>
    {name.slice(0, 1).toUpperCase()}
    <ProfilePicture user={user} />
  </i>
))`
  align-self: center;
  background: ${theme.colors.gray17};
  border-radius: 50%;
  color: ${theme.colors.gray4};
  display: inline-block;
  flex-basis: auto;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  a:hover & {
    background: ${theme.colors.gray16};
  }

  ${({ small }) => (small ? `
    height: ${theme.unit * 4}px;
    line-height: ${theme.unit * 4}px;
    width: ${theme.unit * 4}px;
    margin: ${theme.unit * 0.5}px ${theme.unit}px ${theme.unit * 0.5}px 0;
  ` : `
    height: ${theme.unit * 5}px;
    line-height: ${theme.unit * 5}px;
    width: ${theme.unit * 5}px;
    margin: ${theme.unit * 0.25}px ${theme.unit / 2}px ${theme.unit * 0.25}px 0;
  `)};
`;
TeamIcon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default TeamIcon;



// WEBPACK FOOTER //
// ./src/components/icons/TeamIcon.js